























import { Vue, Component, Prop, Watch, ObjectTypesHelper, AxiosResponse, tlIsBefore } from "../../Infrastructure/CorBase/CoreBase";
import { IContentPreviewService, IReceiverService, ServicesFactory } from "../../Infrastructure/ServicesFactory";

//VaPTODo - presunout do nejakeho axios helperu a vytvoreni prazdneho prazdneho Promise<AxiosResponse> presunout tam
//        - to udelat napric celym kodem
import Axios from "axios";

class ImageResponse {
	id: number = 0;
	image: any = null;
	imageType: string = '';
	imageCheckSum?: string = undefined;
	isValid: boolean = false;
	expiry: number = 0;
}


@Component
export default class BaseTLImage extends Vue {
	@Prop({ type: String, required: false, default: "" }) title?: string;
	@Prop({ type: String, required: false, default: "" }) alt?: string;
	@Prop({ type: Number, required: false, default: 0 }) idEnterPreview?: number | null;
	@Prop({ type: Number, required: false, default: 0 }) idBasePreview?: number | null;
	@Prop({ type: String, required: false, default: "" }) id?: string;
	@Prop({ type: Boolean, required: false, default: false }) lazy?: boolean;
	@Prop({ type: Boolean, required: false, default: true }) useCache?: boolean;
	@Prop({ type: Boolean, required: false, default: true }) fluid?: boolean; //responsivita obrázku
	@Prop({ type: String, required: false, default: "" }) width?: string;
	@Prop({ type: String, required: false, default: "" }) height?: string;
	@Prop({ type: String, required: false, default: "detail" }) typeDesign?: string; //type zobrazeni detail, table, popup, grid
	@Prop({ type: Number, required: false, default: ObjectTypesHelper.ObjectTypeEnum.Receiver }) objectType?: ObjectTypesHelper.ObjectTypeEnum;
	@Prop({ type: Object, required: false, default: null }) item?: any;  //typ souboru ikona - audio, video, image
	@Prop({ type: String, required: false, default: "" }) typeImage?: string;  //typ souboru ikona - audio, video, image

	@Prop({ type: String, required: false, default: null }) fileSumCheck?: string;  //kontrola zda neni novejsi verze
	@Prop({ type: String, required: false, default: null }) fileSumCheckEnter?: string;  //kontrola zda neni novejsi verze

	@Prop({ type: Boolean, required: false, default: false }) showTypeImage?: boolean; // pokud nehceme zobrazit ikony

	@Watch('idBasePreview')
	onPropertyChanged(value: boolean, oldValue: boolean) {
		if (value !== oldValue) {
			//VaP - pokud se zmeni id, tak se jedna o novy obrazek a musime vymazat stara data, at se zobrazuje spravna podoba nahledu a animovaneho nahledu
			this.resetImageData();
			//VaP - pokud doslo ke zmene, ze nove id nema nahled, tak musime nastavit aby se zobrazil defaultSrc, coz udela tato metda kdyz dostane null jako image
			if (!this.idBasePreview || this.idBasePreview == 0) {
				this.setContentPreviewToSrc('', null);
			}
		}
	}

	@Watch('fileSumCheck')
	onPropertyChangedFileCheckSum(value: string, oldValue: string) {
		if (value !== oldValue) {
			//VaP - pokud se zmeni id, tak se jedna o novy obrazek a musime vymazat stara data, at se zobrazuje spravna podoba nahledu a animovaneho nahledu
			this.resetImageData();
			//VaP - pokud doslo ke zmene, ze nove id nema nahled, tak musime nastavit aby se zobrazil defaultSrc, coz udela tato metda kdyz dostane null jako image
			if (!this.idBasePreview || this.idBasePreview == 0) {
				this.setContentPreviewToSrc('', null);
			}
		}
	}

	showIcon = true;

	showIconImage() {
		return this.showTypeImage && this.showIcon && !this.isContentNotImage();
	}

	isContentNotImage() {
		return this.typeImage == "ENU_CON_Content_Type_InfoText" ||
			this.typeImage == "ENU_CON_Content_Type_Audio" || this.typeImage == "ENU_CON_Content_Type_AudioStream"
			|| this.typeImage == "ENU_CON_Content_Type_Nothing" || this.typeImage == "ENU_CON_Content_Type_ScreenOff";
	}

	defaultImageBck() {
		if (this.isContentNotImage()) {
			return this.defaultBlackSrc();
		}
		return this.defaultSrc;
	}

	defaultBlackSrc() {
		if (this.typeImage == "ENU_CON_Content_Type_Audio")
			return require('../../src/BaseRedesign/img_new/audio.webp');
		else if (this.typeImage == "ENU_CON_Content_Type_AudioStream")
			return require('../../src/BaseRedesign/img_new/audio.webp');
		else if (this.typeImage == "ENU_CON_Content_Type_InfoText")
			return require('../../src/BaseRedesign/img_new/info.webp');
		else if (this.typeImage == "ENU_CON_Content_Type_Nothing")
			return require('../../src/BaseRedesign/img_new/nothing.webp');
		else if (this.typeImage == "ENU_CON_Content_Type_ScreenOff")
			return require('../../src/BaseRedesign/img_new/screenoff.webp');
		else
			return require('../../src/BaseRedesign/img_new/screenoff.webp');
	}


	//defaultBlackSrc = require('../../src/BaseRedesign/img_new/screenoff.webp');
	//	defaultSrc = require('../../src/BaseRedesign/img/zastupny_screen_L_01.svg');
	defaultSrc = require('../../src/BaseRedesign/img_new/docasny.jpg');
	contentPreviewService: IContentPreviewService | null = ServicesFactory.getContentPreviewService();
	receiverService: IReceiverService | null = ServicesFactory.getReceiverService();

	//Platnost zaznamu v cache
	private timeToLive: number = 60*60*1000; // hodina
	private cacheKeyPrefix: string = 'image_';

	classImageConect() {
		var result = this.imageByType + " " + this.imageByTypeSize;
		return result;
	}
	get imageByType(): string {
		if (this.typeImage == "ENU_CON_Content_Type_Audio")
			return "iconMediaType_Audio";
		else if (this.typeImage == "ENU_CON_Content_Type_AudioStream")
			return "iconMediaType_Stream";
		else if (this.typeImage == "ENU_CON_Content_Type_HtmlContent")
			return "iconMediaType_Html";
		else if (this.typeImage == "ENU_CON_Content_Type_Image")
			return "iconMediaType_Image";
		else if (this.typeImage == "ENU_CON_Content_Type_InfoText")
			return "iconMediaType_InfoText";
		else if (this.typeImage == "ENU_CON_Content_Type_LinkToUrl")
			return "iconMediaType_Link";
		else if (this.typeImage == "ENU_CON_Content_Type_Nothing")
			return "iconMediaType_Nic";
		else if (this.typeImage == "ENU_CON_Content_Type_ScreenOff")
			return "iconMediaType_ScreenOff";
		else if (this.typeImage == "ENU_CON_Content_Type_Video")
			return "iconMediaType_Video";
		return "iconMediaType_Audio";
	}

	get imageByTypeSize(): string {
		var result = "iconMediaTypeSizeTable";
		if (this.typeDesign == "detail")
			result = "iconMediaTypeSizeDetail";
		else if (this.typeDesign == "popup")
			result = "iconMediaTypeSizePopup";
		else if (this.typeDesign == "table")
			result = "iconMediaTypeSizeTable";
		return result;
	}

	@Watch('id')
	onPropertyChangedId(value: any, oldValue: any) {
		if (value !== oldValue && this.objectType == 1) {
			this.isDefault = this.id == "image_popup_0";
		}
	}

	get styleMain(): string {
		return "width:" + this.width + "; height:" + this.height + ";background-color: red";
	}


	get styleWidth(): string {
		return "max-width:" + this.width + "; max-height: " + this.height;
	}

	get styleImage(): string {
		var result = '';
		result = this.typeDesign == 'detail' || this.typeDesign == 'table' ? "object-fit:scale-down; border : 1px solid black; max-height:" + this.height : result;
		result = this.typeDesign == 'popup' ? "object-fit:scale-down; max-height:" + this.height + ";max-width:" + this.width : result;
		result += this.typeDesign == 'table' ? ";max-width:" + this.width : '';

		result = this.typeDesign == 'grid' ? "object-fit:contain; max-height:" + this.height + ";max-width:" + this.width : result;

		if (this.isDefault) {
			result = result.replace("object-fit:scale-down;", "object-fit:contain;");
		}
		return result;
	}

	enterLast: boolean = false;
	enterLoaded: boolean = false;
	fullId: string = '';
	widthFinal: string = '';
	heightFinal: string = '';

	formData = {
		idBase: 0 as number,
		imageBase: null,
		imageTypeBase: '' as string,
		idEnter: 0 as number,
		imageEnter: null,
		imageTypeEnter: '' as string
	};

	//VaP - zatim resime pouze Content, casem pridame i receiver a nejsi i dalsi stranky
	//    - podle objectType pak bude potreba upravit nektere zobrazene texty a volane metody
	get isContentImage(): boolean {
		return ObjectTypesHelper.isContentObjectType(this.objectType) || ObjectTypesHelper.isTaskPartObjectType(this.objectType);
	}

	get isReceiverImage(): boolean {
		return ObjectTypesHelper.isReceiverObjectType(this.objectType);
	}

	private setDimension() {
		if (this.width && this.width.length > 0) {
			this.widthFinal = this.width;
		}
		if (this.height && this.height.length > 0) {
			this.heightFinal = this.height;
		}
	}

	created() {
		this.setFullId();
	}

	mounted() {
		this.resetImageData();
	}

	resetImageData(): void {
		this.clearOldData();
		this.setDimension();
		this.getAndSetImagePreviewBase();
	}

	clearOldData(): void {
		this.enterLast = false;
		this.enterLoaded = false;
		this.widthFinal = '720px';
		this.heightFinal = '405px';
		this.formData.imageBase = null;
		this.formData.imageEnter = null;
	}

	changeImage(enter: boolean) {
		if (!this.isContentNotImage()) {
			if (enter) {
				// pokud url vrati 400, tak muze dojit k mouseleave a nasledne znovu k mouseenter a vola se porad dokola tato metoda, tak tomu timto zamezime
				if (!this.enterLast) {
					this.getAndSetContentPreviewEnter();
				}
			}
			else {
				if (this.enterLast) {
					this.setImagePreviewBaseToSrc();
				}
			}
			this.enterLast = enter;
		}
	}

	setFullId() {
		if (this.id) {
			this.fullId = this.id;
		}
		this.fullId = this.fullId + '_' + Math.random().toString(36).substr(2, 9);
	}

	setImagePreviewEnterToSrc() {
		this.setContentPreviewToSrc(this.formData.imageTypeEnter, this.formData.imageEnter);
	}

	setImagePreviewBaseToSrc() {
		this.setContentPreviewToSrc(this.formData.imageTypeBase, this.formData.imageBase);
	}

	isDefault = true;
	setContentPreviewToSrc(imageType: string, image: any) {
		let imageElement: HTMLImageElement = (document.getElementById(this.fullId) as HTMLImageElement);
		if (imageElement) {
			if (image) {
				if (!(imageType && imageType.length == 0)) {
					imageType = 'image/webp';
				}
				let newSrc = `data:${imageType};base64,${image}`;
				
				imageElement.src = newSrc;
				this.isDefault = false;
				this.showIcon = false;
			}
			else {
				imageElement.src = this.defaultImageBck();
				this.showIcon = true;
			}
		}
	}

	getAndSetContentPreviewEnter() {
		if (this.idEnterPreview && this.idEnterPreview > 0) {
			//VaP - pri prvnim pokusu o nastaveni obrazku pro enter, musime nacist data
			if (!this.enterLoaded) {
				//VaP - pokud ma idBasePreview stejne jako idEnterPreview, tak nebudeme nic nacitat a pouzijeme jiz nactene data
				if (this.idEnterPreview == this.idBasePreview) {
					this.formData.idEnter = this.formData.idBase;
					this.formData.imageEnter = this.formData.imageBase;
					this.formData.imageTypeEnter = this.formData.imageTypeBase;
					this.setImagePreviewEnterToSrc();
				}
				else {
					const id: number = this.idEnterPreview;
					const checkSum = this.fileSumCheckEnter;
					const imageFromCache: ImageResponse = this.getImageFromCache(id, checkSum);
					if (imageFromCache && imageFromCache.isValid && this.useCache) {
						this.formData.idEnter = imageFromCache.id;
						this.formData.imageEnter = imageFromCache.image;
						this.formData.imageTypeEnter = imageFromCache.imageType;
						this.setImagePreviewEnterToSrc();
					} else {
						this.getResponseById(id).then((response) => {
							if (response.data.image != null && response.data.image != '') {
								if (this.useCache) {
									const imageToCache: ImageResponse = new ImageResponse();
									imageToCache.id = response.data.id;
									imageToCache.image = response.data.image;
									imageToCache.imageType = response.data.imageType;
									imageToCache.isValid = true;
									imageToCache.imageCheckSum = checkSum;
									this.saveImageToCache(id, imageToCache);
								}
								this.formData.idEnter = response.data.id;
								this.formData.imageEnter = response.data.image;
								this.formData.imageTypeEnter = response.data.imageType;
							}
							this.setImagePreviewEnterToSrc();
						});
						this.enterLoaded = true;
					}
				}
			}
			else {
				this.setImagePreviewEnterToSrc();
			}
		}
	}

	getAndSetImagePreviewBase() {
		if (this.idBasePreview && this.idBasePreview > 0) {
			const id: number = this.idBasePreview;
			const checkSum = this.fileSumCheck;
			const imageFromCache: ImageResponse = this.getImageFromCache(id, checkSum);
			if (imageFromCache && imageFromCache.isValid && this.useCache) {
				this.formData.idBase = imageFromCache.id;
				this.formData.imageBase = imageFromCache.image;
				this.formData.imageTypeBase = imageFromCache.imageType;
				this.setImagePreviewBaseToSrc();
				this.showIcon = false;
			} else {
				this.getResponseById(id).then((response) => {
					if (response.data.image != null && response.data.image != '') {
						if (this.useCache) {
							const imageToCache: ImageResponse = new ImageResponse();
							imageToCache.id = response.data.id;
							imageToCache.image = response.data.image;
							imageToCache.imageType = response.data.imageType;
							imageToCache.isValid = true;
							imageToCache.imageCheckSum = checkSum;
							this.saveImageToCache(id, imageToCache);
						}
						this.formData.idBase = response.data.id;
						this.formData.imageBase = response.data.image;
						this.formData.imageTypeBase = response.data.imageType;
						
					}
					this.setImagePreviewBaseToSrc();
					this.showIcon = false;
				}).catch(() => {
					this.showIcon = true;
				});
			}
		} else {
			this.showIcon = true;
		}
	}

	//VaP - zatim to ulozime do session storage, ale ta je pry limitovana na 5MB dat, coz ty obrazky muzou mit vic, ale delat to do indexedDb mi prijde jako moc veliky voser zatim
	//        - https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
	saveImageToCache(id: number, imageResponse: ImageResponse) {
		if (imageResponse == null || imageResponse.image == null || imageResponse.image == '')
			return;

		let sessionId = this.getSessionStorageItemId(id);
		//VaP pouze u receiveru nastavime platnost, jelikoz u nej se printscreeny zařízení meni, u obrazku nastavime temer neomezenou platnost, jelikoz ty by se menit nemely
		if (this.isReceiverImage) {
			imageResponse.expiry = new Date().getTime() + this.timeToLive;
		}
		else {
			imageResponse.expiry = new Date().getTime() + this.timeToLive * 24; // den
		}
		try {
			sessionStorage.setItem(sessionId, JSON.stringify(imageResponse));
			//console.log('saveImageToCache', sessionId, new Date(imageResponse.expiry).toISOString(), imageResponse.imageCheckSum);
			const size = this.totalCacheSize();
			const avg = Math.round(size.totalSize / size.count);
			//console.log("Local storage size after save:", Math.round(size.totalSize / 1024.0), "KiB", size.count, "items", avg, "bytes per item");
		} catch (ee) {
			var e: any = ee;
			if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED") {
				//const size = this.totalCacheSize();
				//console.log("Local storage is full.", size.totalSize / 1024.0, "KiB (json data)", size.count, "items");
				const cacheCleared = this.clearOldCache();
				this.$nextTick(function () {
					try {
						if (cacheCleared && sessionStorage.getItem(sessionId) != null) {
							sessionStorage.setItem(sessionId, JSON.stringify(imageResponse));
							//console.log('saveImageToCache after clear', sessionId, new Date(imageResponse.expiry).toISOString());
						}
					} catch (e) {
						console.error("saveImageToCache after clear error", e);
					}
				});
			} else {
				console.error("Unexpected error when accessing local storage:", e);
			}
		}
	}

	totalCacheSize() {
		//const start = new Date().getTime();
		let totalSize = 0;
		let count = 0;
		for (let i = 0; i < sessionStorage.length; i++) {
			let key = sessionStorage.key(i);
			if (!key)
				continue;
			let dataFromSession: any = sessionStorage.getItem(key);
			count++;
			totalSize += dataFromSession.length;
		}
		//console.log("totalCacheSize", new Date().getTime() - start, "ms", totalSize / 1024.0, "KiB", count, "items");
		return {totalSize, count};
	}	

	clearOldCache(cacheInfo?: {totalSize: number; count: number}): boolean {
		const minRemoved = 10;
		let removed = 0;
		let removedBytes = 0;
		try {
			const itemMap: {key: string; expiry: number; size: number}[] = [];

			for (let i = 0; i < sessionStorage.length; i++) {
				let key = sessionStorage.key(i);
				if (key && key.startsWith(this.cacheKeyPrefix)) {
					let dataFromSession: any = sessionStorage.getItem(key);
					if (dataFromSession != null)
						itemMap.push({key: key, expiry: JSON.parse(dataFromSession).expiry, size: dataFromSession.length});
				}
			}
			//Seřadíme podle expirace
			itemMap.sort((a, b) => a.expiry - b.expiry);
			const expired = itemMap.filter(item => tlIsBefore(item.expiry, new Date().getTime()));
			//Vymažeme expired položky
			for (let i = 0; i < expired.length; i++) {
				sessionStorage.removeItem(expired[i].key);
				//console.log('clearOldCache expired', expired[i].key, new Date(expired[i].expiry).toISOString());
				removed++;
				removedBytes += expired[i].size;
			}
			//Vymažeme položky, dokud se nevejdeme do limitu
			for (let i = 0; i < itemMap.length && removed < minRemoved; i++) {
				let key = itemMap[i].key;
				sessionStorage.removeItem(key);
				//console.log('clearOldCache oldest', key, new Date(itemMap[i].expiry).toISOString());
				removed++;
				removedBytes += itemMap[i].size;
			}
			//console.info("Cleared old cache items:", removed, "items", removedBytes, "bytes");
		} catch (e) {
			console.error("Error clearing local storage:", e);
		}
		return removed > 0;
	}

	getImageFromCache(id: number, checkSum?: string): ImageResponse {
		let sessionId = this.getSessionStorageItemId(id);
		let returnValue: ImageResponse = new ImageResponse();
		returnValue.id = 0;
		returnValue.image = null;
		returnValue.imageType = '';
		returnValue.isValid = false;

		let dataFromSession: any = sessionStorage.getItem(sessionId);
		if (dataFromSession) {
			try {
				//VaP - musime jeste overit, ze data v localstorage nejsou stare
				let tmpReturnValue: ImageResponse = JSON.parse(dataFromSession);
				if (tlIsBefore(new Date().getTime(), tmpReturnValue.expiry) && tmpReturnValue.imageCheckSum == checkSum) {
					returnValue = tmpReturnValue;
					//console.log('getImageFromCache valid cache item', sessionId, new Date(returnValue.expiry).toISOString(), tmpReturnValue.imageCheckSum, checkSum);
				} else {
					sessionStorage.removeItem(sessionId);
					//console.log('getImageFromCache old cache item', sessionId, new Date(returnValue.expiry).toISOString(), tmpReturnValue.imageCheckSum, checkSum);
				}
			} catch (e) {
				console.log('getImageFromCache error', sessionId, e);
			}
		}
		else
		{
			//console.log('getImageFromCache no cache item', sessionId);
		}
		return returnValue;
	}

	getSessionStorageItemId(id: number) {
		let sessionId: string = this.cacheKeyPrefix;
		if (this.isReceiverImage) {
			sessionId += 'receiver_';
		}
		else
		{
			sessionId += 'content_';
		}

		var result = sessionId + id.toString(); // Kurth: toto sem nepatri, nelze potom najit starsi verze obrazku a odstranit z cache + "_" + this.fileSumCheck;
		return result;
	}

	//getResponseById(id: number): Promise<AxiosResponse> {
	//	if (this.isReceiverImage) {
	//		return this.receiverService.getPreviewById(id);
	//	}
	//	//VaP - vychozi bude content
	//	return this.contentPreviewService.getById(id);
	//	//return Axios.get('/');
	//}

	getResponseById(id: number): Promise<AxiosResponse> {
		if (this.isReceiverImage) {
			if (this.receiverService != null) {
				return this.receiverService.getPreviewById(id);
			}
		}
		//VaP - vychozi bude content
		if (this.contentPreviewService != null) {
			return this.contentPreviewService.getById(id);
		}
		return Axios.get('/');
	}
}
